<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { BRAND, isBrandBuild } from '../brand'
import { icon } from '../lib/icons'
import { useUiStore } from '../stores/ui'

const { t } = useI18n()
const ui = useUiStore()
const brand = isBrandBuild
const emit = defineEmits<{ openSettings: []; showCover: []; openAccount: [] }>()

// 익명 빌드(none)는 BRAND.appName이 'Workspace'라 브랜드가 노출되지 않는다. 업무 모드도 평범한 이름.
const brandLabel = computed(() => (ui.stealth ? 'Workspace' : BRAND.appName))
</script>

<template>
  <header class="top">
    <div class="brand">{{ brandLabel }}</div>
    <div class="top-r">
      <button class="mode-sw" :aria-pressed="ui.stealth" @click="ui.toggleStealth()">
        <i></i><span>{{ t('header.workMode') }}</span>
      </button>
      <button
        class="icon-gear" :aria-pressed="ui.motionActive" :aria-label="t('header.animation')"
        @click="ui.setMotion(ui.motionActive ? 'off' : 'on')"
        v-html="icon('sparkle')"
      ></button>
      <button v-if="brand" class="icon-gear" :aria-label="t('account.title')" :title="t('account.title')" @click="emit('openAccount')" v-html="icon('user')"></button>
      <button class="icon-gear" :aria-label="t('header.settings')" :title="t('header.settings')" @click="emit('openSettings')" v-html="icon('gear')"></button>
      <button class="boss" @click="emit('showCover')"><kbd>{{ t('header.boss') }}</kbd><span>{{ t('header.bossHint') }}</span></button>
    </div>
  </header>
</template>
